module.exports = __webpack_public_path__ + "static/media/vip-message-icon.66376d17.png";